import { Component, OnInit } from '@angular/core'; 
import { NgForm } from '@angular/forms';
import { TeamService } from './team.service';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { Teams } from '../model/Teams';
import { Router } from '@angular/router';
import { HelperService } from '../services/helper-service';
import { ManageUserService } from '../services/manage-user-service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-team-create',
  standalone: true,
  imports: [MatInputModule, MatFormFieldModule, FormsModule, CommonModule],
  templateUrl: './team-create.component.html',
  styleUrls: ['./team-create.component.css'],
})
export class TeamCreateComponent implements OnInit {
  cities: any[] = [];
  states: any[] = [];
  state = 'Andaman and Nicobar Islands';
  city = 'Port Blair';
  country = 'india';
  doctor: any;
  zipCode: string = '';
  addressLine1 = '';
  addressLine2 = '';
  emmgram = 'Choose Option';
  countries: any[] = [];
  diabetesTypeArr: any[] = [];
  diabetesSub: any[] = [];
  team: Teams = {
    teamId: '',
    teamName: '',
    teamType: '',
    description: '',
    ageOfDibeties: '',
    teamAddress: {
      addressLine1: '',
      state: '',
      city: '',
      addressLine2: '',
      zipCode: '',
      country: ''
    },
    enneagramType: {
      id: '',
      name: '',
      description: ''
    },
    diabetesType: '',
    diabetesSubType: '',
    status: '',
    userIds: [],
    policy: '',
    usersAssigned: []
  };
  userList: any[] = [];
  selectedDoctor = '';
  fitnessId = '';
  nutrientId = '';
  phyId = '';
  memberAdvocateId = '';
  allDoctors: any[] = [];
  allFitness: any[] = [];
  allNutrient: any[] = [];
  allPhy: any[] = [];
  allMemberAdvocate: any[] = [];
  enngramTest: any[] = [];
  selectedEnngramType = '';
  selectedDiabetesType = '';
  selectedMemberAdvocate = '';
  selectedFitnessInstructor = '';
  selectedNutritionist = '';
  selectedPhysiotherapist = '';
  selectedPolicy = '';

  constructor(
    private manageUserService: ManageUserService,
    private helperService: HelperService,
    private router: Router,
    private teamService: TeamService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.loadUsers();
    this.loadCountryStateData('india');
    this.loadEnneagramTypes();
    this.loadDiabetesTypes();
  }

  private loadUsers(): void {
    this.manageUserService.getAllUsers('', '', 100).subscribe((response: any) => {
      this.userList = response;
      this.allMemberAdvocate = this.filterUsersByRole('Member Advocate');
      this.allDoctors = this.filterUsersByRole('Doctor');
      this.allNutrient = this.filterUsersByRole('Nutritionist');
      this.allFitness = this.filterUsersByRole('Fitness Instructor');
      this.allPhy = this.filterUsersByRole('Psychologists');
    });
  }

  private filterUsersByRole(role: string): any[] {
    return this.userList.filter((user: any) =>
      user.userRoles?.some((userRole: any) => userRole.userRole === role)
    );
  }

  private loadCountryStateData(country: string): void {
    this.helperService.getCountryStateForAddForm(country).subscribe((response: any) => {
      this.countries = response;
      this.cities = response[1];
      this.states = response[2];
    });
  }

  private loadEnneagramTypes(): void {
    this.teamService.getEnneagramType().subscribe((response: any) => {
      this.enngramTest = response;
    });
  }

  private loadDiabetesTypes(): void {
    this.teamService.getDiabetesType().subscribe((response: any) => {
      this.diabetesTypeArr = response;
    });
  }

  onSubmit(): void {
    this.addTeam();
  }

  getCountry(event: any): void {
    const country = event.target.value;
    this.loadCountryStateData(country);
    this.country = country;
    this.state = '';
    this.city = '';
  }

  SelectedRow(event: any): void {
    const selectedState = event.target.value;
    const cityList = this.countries[2]?.filter((state: any) => state.name === selectedState);
    this.cities = cityList[0]?.cities || [];
    this.city = '';
  }

  addTeam(): void {
    if (!this.isFormValid()) {
      return;
    }
    const selectedEnneagram = this.enngramTest.find((x: any) => x.id === this.emmgram);
    if (selectedEnneagram) {
      this.team.enneagramType = {
        id: selectedEnneagram.id,
        name: selectedEnneagram.name,
        description: selectedEnneagram.description
      };
    }

    this.addSelectedUsersToTeam();

    this.team.teamAddress = {
      state: this.state,
      addressLine1: '',
      addressLine2: '',
      city: this.city,
      country: this.country,
      zipCode: ''
    };

    this.teamService.addTeam(this.team).subscribe(() => {
      this.toast.successMessage('Team Added successfully');
      setTimeout(() => (window.location.href = 'teams'), 5000);
    });
  }

  private isFormValid(): boolean {
    if(!this.team.teamName){
      this.toast.errorMessage('Please enter team name.');
    }
    else if(!this.emmgram || this.emmgram === 'Choose Option'){
      this.toast.errorMessage('Please select engram type.');
    }
    else if(!this.team.diabetesType){
      this.toast.errorMessage('Please select diabetes type.');
    }
    else if(!this.memberAdvocateId){
      this.toast.errorMessage('Please select member advocate.');
    }
    else if(!this.state){
      this.toast.errorMessage('Please select state.');
    }
    else if(!this.city){
      this.toast.errorMessage('Please select city.');
    }
    return (
      !!this.emmgram &&
      !!this.team.teamName &&
      !!this.team.diabetesType &&
      !!this.memberAdvocateId &&
      !!this.state &&
      !!this.city
    );
  }

  private addSelectedUsersToTeam(): void {
    [this.selectedDoctor, this.memberAdvocateId, this.nutrientId, this.fitnessId, this.phyId].forEach((id) => {
      if (id) this.team.userIds.push(id);
    });
  }

  SelectLevel(event: any): void {
    this.team.teamType = event.target.value;
  }

  selectEnngramType(event: any): void {
    this.emmgram = event.target.value;
  }

  selectDiabetesType(event: any): void {
    this.team.diabetesType = event.target.value;
  }

  selectDoctor(event: any): void {
    this.selectedDoctor = event.target.value;
  }

  selectMemberAdvocate(event: any): void {
    this.selectedMemberAdvocate = event.target.value;
    this.memberAdvocateId = this.selectedMemberAdvocate;
  }

  selectFitnessInstructor(event: any): void {
    this.selectedFitnessInstructor = event.target.value;
    this.fitnessId = this.selectedFitnessInstructor;
  }

  selectNutritionist(event: any): void {
    this.selectedNutritionist = event.target.value;
    this.nutrientId = this.selectedNutritionist;
  }

  selectPhysiotherapist(event: any): void {
    this.selectedPhysiotherapist = event.target.value;
    this.phyId = this.selectedPhysiotherapist;
  }

  selectPolicy(event: any): void {
    this.selectedPolicy = event.target.value;
    this.team.policy = this.selectedPolicy;
  }
}
